import { faEdit, faLock, faLockOpen, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from "react-router";
import { updateActive, upsert, carregaUsuariosComFiltro, carregaUsuarios } from '../../../../services/usuarios';
import { hasPermission } from "../../../../utils/utils";
import "./UsuariosCrud.css";

export default function UsuariosCrud() {

    const {register, handleSubmit} = useForm();
    const history = useHistory();
    const [usuarios, setUsuarios] = useState([]);

    const carregarUsuarios = useCallback(async () => {
        const res = await carregaUsuarios();
        setUsuarios(res);
    }, []);

    useEffect(()=>{
        carregarUsuarios();
    },[carregarUsuarios])

    const editElement = (id) => {
        history.push(`/usuarios/editar/${id}`);
    };

    const changeActive = async (id) => {
        await updateActive(id);
        carregarUsuarios();;
    };

    const logicalDelete = async (id) => {
        if (window.confirm("Tem certeza que deseja deletar o registro?")) {
            const obj = { deleted: true };
            await upsert(obj, id);
        }
        carregarUsuarios();
    };

    const onSubmit = obj => {
        const novoObj = Object.values(obj).toString()
        save(novoObj);
    };

    const save = async (obj) => {
        const res = await carregaUsuariosComFiltro(obj);
        setUsuarios(res)
    };

    const renderItens = () => {
        if (usuarios.length > 0) {
            return usuarios.map((ele, index) => {
                return (
                    <tr key={index}>
                        <td>{ele.nome}</td>
                        <td>{ele.login}</td>
                        <td>{ele.grupo.nome}</td>
                        <td>{ele.active === true ? "Ativo" : "Inativo"}</td>
                        <td className="actions">
                            {hasPermission('usuarios', 'editar') && <button onClick={() => { editElement(ele._id) }}><FontAwesomeIcon icon={faEdit} /></button>}
                            {hasPermission('usuarios', 'editar') && <button onClick={() => { changeActive(ele._id) }}><FontAwesomeIcon icon={ele.active === true ? faLock : faLockOpen} /></button>}
                            {hasPermission('usuarios', 'deletar') && <button onClick={() => { logicalDelete(ele._id) }}><FontAwesomeIcon icon={faTrashAlt} /></button>}
                        </td>
                    </tr>
                )
            })
        } else {
            return (
                <tr>
                    <td>Nenhum registro encontrado</td>
                </tr>
            )
        }
    }

    return (
        <div className="UsuariosCrud">
            <div className="row">
                <div className="search">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <input type="text" name="search" ref={register()}/>
                        <button className="Btn Btn-confirm" type="submit">Pesquisar</button>
                        <button className="Btn Btn-confirm" type="button" onClick={()=>{carregarUsuarios()}}>Limpar filtro</button>
                    </form>
                </div>
                <div className="add">
                    {hasPermission('usuarios', 'criar') && <button className="Btn Btn-confirm" onClick={() => history.push(`usuarios/adicionar`)}>Adicionar</button>}
                </div>
            </div>
            <div className="row">
                <table>
                    <thead>
                        <tr>
                            <td>Nome</td>
                            <td>Login</td>
                            <td>Grupo</td>
                            <td>Status</td>
                            <td>Ações</td>
                        </tr>
                    </thead>
                    <tbody>
                        {renderItens()}
                    </tbody>
                </table>
            </div>
        </div>
    )
}